<div *ngIf="!isEditable">
              <div class="tile-container">
                    <div class="tile">
                      ER Contribution <br />
                      {{contributions.employerMonthlyContributionAmount | currency: contributions.currencyCode : 'symbol-narrow'}}
                    </div>
                    <div class="tile">
                      ER Once-off <br />
                      {{contributions.employerOnceOffContributionAmount | currency: contributions.currencyCode : 'symbol-narrow'}}
                    </div>
                    <div class="tile">
                      ER Contribution(%) <br />
                      {{contributions.employerMonthlyContributionPercentage}}
                    </div>
                    <div class="tile">
                      Total Contribution <br />
                      {{(contributions.employerMonthlyContributionAmount+contributions.employeeMonthlyContributionAmount) | currency: contributions.currencyCode : 'symbol-narrow'}}
                    </div>
                    <div class="tile">
                      Future Value <br />
                      {{contributions.futureValue | currency: contributions.currencyCode : 'symbol-narrow'}}
                    </div>
              </div>
              <div class="tile-container">
                    <div class="tile">
                      EE Contribution <br />
                      {{contributions.employeeMonthlyContributionAmount | currency: contributions.currencyCode : 'symbol-narrow'}}
                    </div>
                    <div class="tile">
                      EE Once-off <br />
                      {{contributions.employeeOnceOffContributionAmount | currency: contributions.currencyCode : 'symbol-narrow'}}
                    </div>
                    <div class="tile">
                      EE Contribution(%) <br />
                      {{contributions.employeeMonthlyContributionPercentage}}
                    </div>
                    <div class="tile">
                      Total Contribution(%) <br />
                      {{contributions.employerMonthlyContributionPercentage+contributions.employeeMonthlyContributionPercentage}}
                    </div>
                    <div class="tile">
                      Future Value in Today's Money<br />
                      {{contributions.futureValueInTodaysMoney | currency: contributions.currencyCode : 'symbol-narrow'}}
                    </div>
              </div>
              <div class="tile-container">
                    <div class="tile">
                      Term of Investment <br />
                      {{contributions.originalTermDescription}}
                    </div>
                    <div class="tile">
                    </div>
                    <div class="tile">
                    </div>
                    <div class="tile">
                    </div>
                    <div class="tile">
                    </div>
              </div>
</div>

<div *ngIf="isEditable">
              <div class="tile-container" style="overflow: auto;">
                    <div class="tile">
                      ER Contribution <br />

                      <dx-number-box
                        [(value)]="clonnedContributions.employerMonthlyContributionAmount"
                        format="R #,##0.00"
                        [showSpinButtons]="false"
                        [showClearButton]="true" (onValueChanged)="onEmployerMonthlyContributionChange($event)"
                        [placeholder]="'Enter amount'">
                      </dx-number-box>
                    </div>
                    <div class="tile">
                      ER Once-off <br />
                      <dx-number-box
                        [(value)]="clonnedContributions.employerOnceOffContributionAmount"
                        format="R #,##0.00"
                        [showSpinButtons]="false"
                        [showClearButton]="true"
                        [placeholder]="'Enter amount'">
                      </dx-number-box>
                    </div>
                    <div class="tile">
                      ER Contribution(%) <br />
                      <dx-number-box
                        [(value)]="clonnedContributions.employerMonthlyContributionPercentage"
                        format="#0.0#" (onValueChanged)="onEmployerMonthlyContributionPercentChange($event)"
                        [showSpinButtons]="false"
                        [showClearButton]="true"
                        [placeholder]="'Enter percent'">
                      </dx-number-box>
                    </div>
                    <div class="tile">
                      Total Contribution <br />
                      {{(clonnedContributions.employerMonthlyContributionAmount+clonnedContributions.employeeMonthlyContributionAmount) | currency: contributions.currencyCode : 'symbol-narrow'}}
                    </div>
                    <div class="tile">
                      Future Value <br />
                      {{clonnedContributions.futureValue | currency: clonnedContributions.currencyCode : 'symbol-narrow'}}
                    </div>
              </div>
              <div class="tile-container">
                    <div class="tile">
                      EE Contribution <br />
                      <dx-number-box
                        [(value)]="clonnedContributions.employeeMonthlyContributionAmount"
                        format="R #,##0.00" (onValueChanged)="onEmployeeMonthlyContributionChange($event)"
                        [showSpinButtons]="false"
                        [showClearButton]="true"
                        [placeholder]="'Enter amount'">
                      </dx-number-box>
                    </div>
                    <div class="tile">
                      EE Once-off <br />
                      <dx-number-box
                        [(value)]="clonnedContributions.employeeOnceOffContributionAmount"
                        format="R #,##0.00"
                        [showSpinButtons]="false"
                        [showClearButton]="true"
                        [placeholder]="'Enter amount'">
                      </dx-number-box>
                    </div>
                    <div class="tile">
                      EE Contribution(%) <br />
                      <dx-number-box
                        [(value)]="clonnedContributions.employeeMonthlyContributionPercentage"
                        format="#0.0#" (onValueChanged)="onEmployeeMonthlyContributionPercentChange($event)"
                        [showSpinButtons]="false"
                        [showClearButton]="true"
                        [placeholder]="'Enter percent'">
                      </dx-number-box>
                    </div>
                    <div class="tile">
                      Total Contribution(%) <br />
                      {{clonnedContributions.employerMonthlyContributionPercentage+clonnedContributions.employeeMonthlyContributionPercentage}}
                    </div>
                    <div class="tile">
                      Future Value in Today's Money<br />
                      {{clonnedContributions.futureValueInTodaysMoney | currency: clonnedContributions.currencyCode : 'symbol-narrow'}}
                    </div>
              </div>
              <div class="tile-container">
                    <div class="tile">
                      Term of Investment <br />
                      {{contributions.originalTermDescription }}
                    </div>
                    <div class="tile">
                    </div>
                    <div class="tile">
                    </div>
                    <div class="tile">
                    </div>
                    <div class="tile">
                    </div>
              </div>
</div>

<div style="text-emphasis: none;text-align: end;font-size: 13px;font-weight: 600;">
  Last Updated: {{contributions.currentValueLastRetrievedDate | date:'d MMM y hh:mm:ss'}}
</div>